import request from '@/config/axios'
import type { FirmAlertItemVO } from '@/api/lawyer/firmDossier'

export interface FirmDashboardSummaryVO {
  todayHearingCount?: number
  upcomingDeadlineCount?: number
  overdueTaskCount?: number
  overdueDeadlineCount?: number
  expiringContractCount?: number
  pendingTimeEntryCount?: number
  openReceivableCount?: number
  outstandingAmount?: number
  focusItems?: FirmAlertItemVO[]
}

export const FirmDashboardApi = {
  summary: (focusLimit = 15) =>
    request.get<FirmDashboardSummaryVO>({
      url: '/lawyer/firm/dashboard/summary',
      params: { focusLimit }
    })
}
